// @flow

import {nodeMarkdoc} from './nodeMarkdoc';
import {edgeMarkdoc} from './edgeMarkdoc';
import type {MockEdge} from './mockEdge';
import type {MockNode} from './mockNode';

export const diagramMarkdoc = (
  type: string,
  description: string,
  nodes: Array<MockNode>,
  edges: Array<MockEdge>,
): string => {
  return `{% diagram type="${type}" description="${description}" %}\n${nodes
    .map(nodeMarkdoc)
    .join('\n')}\n${edges.map(edgeMarkdoc).join('\n')}\n{% /diagram %}`;
};
